import React, { useState } from "react";
import { Button, Divider, Flex, Heading, Text } from "@cisco/spaces-dash-lib-styleguide";
import { WebClient } from "@cisco/spaces-dash-lib-web";
import { CustomerItem } from "../../../types/components";
import DropdownSimple from "./dropdown-simple";

interface SupportSelectionProps {
  supportCustomerList: CustomerItem[];
  onLoginSuccess: () => void;
}

export function SupportSelection(props: SupportSelectionProps): JSX.Element {
  const { supportCustomerList, onLoginSuccess } = props;

  const [selectedCustomer, setSelectedCustomer] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSelect = (value: number) => {
    const selectedCust = supportCustomerList.find((cust) => cust.tenantId === value);
    if (selectedCust?.accountStatus === "EXPIRED") {
      setSelectedCustomer(null);
      return;
    }
    setSelectedCustomer(value);
  };

  const loginSuccess = () => {
    onLoginSuccess();
  };

  const getUserStatus = async () => {
    try {
      const fetchUserStatus = await fetch("/api/v1/user/current/status");
      const userStatusData = await fetchUserStatus.json();
      const { data } = userStatusData;
      sessionStorage.setItem("isSmartLicenseRegistered", data?.isSmartLicenseRegistered);
      sessionStorage.setItem("isSmartLicenseNeeded", data?.isSmartLicenseNeed);
      sessionStorage.setItem("accountServices", JSON.stringify(data?.licenseDetails?.subscribedServices));
      sessionStorage.setItem("tenantId", String(data?.licenseDetails?.tenantId));
      if (data.licenseDetails && data.licenseDetails.status === "Expired") {
        window.location.href = "/login";
      } else {
        loginSuccess();
      }
    } catch (error) {
      console.error("Error user status:: ", error);
    }
  };

  const getAccount = (id: number) => {
    WebClient.get(`/api/tm/v1/account/services/${id}`)
      .then(() => {
        getUserStatus();
      })
      .catch((error: any) => {
        console.error("Error getAccount::", error);
      });
  };

  const submitForm = () => {
    if (!selectedCustomer) {
      return false;
    }
    setIsLoading(true);
    return getAccount(selectedCustomer);
  };

  return (
    <Flex direction="vertical">
      <Heading as="h2" margin={{ bottom: 16 }} size="primary">
        Search Account
      </Heading>
      <Text size="p4" weight="regular">
        Search accounts by Customers Name or Account ID or Tenant ID
      </Text>
      <Divider />
      <DropdownSimple listItems={supportCustomerList} onDropdownSelect={handleSelect} />
      <Divider />
      <Flex justify="flex-end">
        <Button.Group>
          <Button onClick={submitForm} disabled={supportCustomerList.length === 0 && !selectedCustomer} loading={isLoading}>
            Proceed
          </Button>
        </Button.Group>
      </Flex>
    </Flex>
  );
}
